var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_2773)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "#07EFB8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2773)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7211 16.7013C24.3671 16.6582 25.0145 16.7593 25.6173 16.9974C26.0025 17.1402 26.3646 17.3398 26.6917 17.5896C27.0055 17.8291 27.285 18.111 27.5224 18.4275C28.0532 19.1291 28.3686 19.9722 28.4295 20.8525C28.4782 21.5876 28.3464 22.3235 28.0458 22.9949C27.7453 23.6664 27.2852 24.2526 26.7064 24.7018C26.097 25.1681 25.3795 25.4693 24.6221 25.5765C23.8647 25.6838 23.0927 25.5937 22.3796 25.3148C21.6257 25.0191 20.9688 24.5165 20.4833 23.8639C20.0159 23.2554 19.7134 22.5347 19.6053 21.7727C19.4973 21.0107 19.5874 20.2335 19.8669 19.5172C19.9683 19.2542 20.0941 19.0014 20.2426 18.7621L20.5919 18.2735C20.6364 18.2284 20.6785 18.181 20.7181 18.1314C21.3316 17.3675 22.6291 16.7368 23.7211 16.6806V16.7013ZM30.3845 17.6162C30.5331 17.576 30.6915 17.5963 30.8254 17.6727C30.9594 17.7492 31.0582 17.8756 31.1007 18.0249C31.1439 18.176 31.1258 18.3383 31.0504 18.476C30.975 18.6137 30.8484 18.7156 30.6985 18.7592C30.5487 18.8028 30.3878 18.7845 30.2513 18.7084C30.1148 18.6324 30.0138 18.5047 29.9706 18.3535C29.9488 18.2777 29.9423 18.1983 29.9514 18.1198C29.9605 18.0414 29.9851 17.9657 30.0236 17.897C30.0622 17.8283 30.114 17.768 30.1759 17.7198C30.2379 17.6716 30.3088 17.6364 30.3845 17.6162ZM15.0263 25.907C15.0615 26.16 15.1467 26.4033 15.2768 26.6225C15.4069 26.8417 15.5793 27.0324 15.7837 27.1832C16.3473 27.5444 16.7054 27.5177 17.4716 27.5177H29.5948C30.2556 27.5523 30.918 27.5355 31.5762 27.4674C31.8207 27.4133 32.0513 27.3085 32.2534 27.1596C32.4556 27.0108 32.6248 26.8212 32.7504 26.6028C33.0733 26.058 32.9999 25.4776 32.9999 24.7996V18.6822C32.9999 18.09 33.0733 17.2964 32.8326 16.8019C32.225 15.5169 31.0714 15.7093 29.8708 15.7093C29.1721 15.7093 28.5733 15.8278 28.3473 15.2149C27.6222 13.2429 27.9715 13.0059 26.4833 13.0059H21.4167C21.0498 13.0059 20.8297 12.9556 20.5361 13.1422C20.2426 13.3287 20.2426 13.4086 20.1369 13.761C20.0547 14.0127 19.9696 14.2585 19.8874 14.519C19.7113 15.055 19.6379 15.6412 19.0538 15.7034C18.7808 15.736 18.3316 15.7034 18.041 15.7034C17.0841 15.7034 16.2093 15.5702 15.5342 16.2483C15.3489 16.4509 15.2069 16.6897 15.1171 16.95C15.0272 17.2103 14.9913 17.4864 15.0117 17.7613V21.8475C15.0117 22.57 14.9706 25.4303 15.0117 25.9099L15.0263 25.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7711 18.4453C23.4143 18.4733 23.0666 18.5723 22.748 18.7365C22.4293 18.9008 22.1461 19.1272 21.9147 19.4025C21.6832 19.6778 21.5082 19.9966 21.3995 20.3405C21.2909 20.6844 21.2509 21.0467 21.2819 21.4063C21.3271 21.899 21.5036 22.3701 21.7926 22.77C22.0816 23.1698 22.4723 23.4834 22.9235 23.6775C23.3747 23.8717 23.8695 23.9393 24.3556 23.873C24.8417 23.8068 25.3011 23.6092 25.685 23.3013C25.8866 23.1642 26.0593 22.9881 26.1928 22.7831C26.2251 22.7387 26.275 22.6558 26.3249 22.5788C26.4132 22.43 26.4878 22.2734 26.548 22.111C26.7028 21.6773 26.7475 21.2115 26.678 20.7559C26.6084 20.3003 26.4268 19.8695 26.1498 19.503C25.8728 19.1364 25.5092 18.8456 25.0921 18.6572C24.6751 18.4689 24.2179 18.3889 23.7623 18.4245L23.7711 18.4453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_2773",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_2773"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_2773",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14.5385,
    fill: "white",
    transform: "translate(15 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.791a1ad9e42600546e24fd0357f6d3f0.svg";
export { ForwardRef as ReactComponent };